let config = {
  TF_HUB_BACKEND_URL: import.meta.env.VITE_TF_HUB_BACKEND_URL
    ? import.meta.env.VITE_TF_HUB_BACKEND_URL
    : 'http://localhost:3010',
  GOOGLE_OAUTH_CLIENT_ID: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID
    ? import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID
    : '',
  GIPHY_API_URL: import.meta.env.VITE_GIPHY_API_URL ? import.meta.env.VITE_GIPHY_API_URL : 'https://api.giphy.com',
  GIPHY_API_TOKEN: import.meta.env.VITE_GIPHY_API_TOKEN
    ? import.meta.env.VITE_GIPHY_API_TOKEN
    : 'rOxOdgNQw7dCctBD8rcXsH9n6fWyjaMm',
  SECURITY_WIKI_PAGE_URL: import.meta.env.VITE_SECURITY_WIKI_PAGE_URL
    ? import.meta.env.VITE_SECURITY_WIKI_PAGE_URL
    : 'https://techfides.atlassian.net/wiki/spaces/TF/pages/37410/Bezpe+nost+a+profesionalita+v+voje',
  TENANT: import.meta.env.VITE_TENANT ? import.meta.env.VITE_TENANT : 'tf',
  ULA_URL: import.meta.env.VITE_ULA_URL ? import.meta.env.VITE_ULA_URL : 'http://localhost:8013',
  INSTANCE_TYPE: import.meta.env.VITE_INSTANCE_TYPE ?? '',
};

interface Config {
  TF_HUB_BACKEND_URL: string;
  GOOGLE_OAUTH_CLIENT_ID: string;
  GIPHY_API_URL: string;
  GIPHY_API_TOKEN: string;
  SECURITY_WIKI_PAGE_URL: string;
  TENANT: string;
  ULA_URL: string;
  INSTANCE_TYPE: string;
}
export const setConfig = (configData: Config): void => {
  config = configData;
};

export const getTenantColor = () => {
  switch (config.TENANT) {
    case 'tf':
      return 'blue';
    case 'rtsg':
      return 'orange';
    default:
      return 'green';
  }
};

export const getConfig = (): Config => config;
